import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { User } from "lucide-react";
export default function TourTypeCard(_a) {
    var _b;
    var option = _a.option, onSelect = _a.onSelect;
    var Icon = (_b = option === null || option === void 0 ? void 0 : option.icon) !== null && _b !== void 0 ? _b : User;
    return (React.createElement(Card, { key: option.value, className: "cursor-pointer hover:border-primary transition-colors", onClick: function () { return onSelect(option.value); } },
        React.createElement(CardContent, { className: "flex flex-col items-center justify-center p-6" },
            React.createElement(Icon, { className: "h-12 w-12 mb-4 text-primary" }),
            React.createElement("h4", { className: "text-lg font-semibold" }, option.label),
            React.createElement("p", { className: "text-sm text-muted-foreground text-center mt-1" }, option.description))));
}
